(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name rols.llista.controller:LlistaCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.rols.main.llista')
    .controller('RolsMainLlistaCtrl', RolsMainLlistaCtrl);

  function RolsMainLlistaCtrl($translate,$rootScope,$scope, HelperFactory, Notification, RolFactory, $window, $state, $stateParams,llistaentitats) {
    var vm = this;
    vm.ctrlName = 'RolsMainLlistaCtrl';

    vm.calculateListFields = calculateListFields;
    vm.load = load;
    vm.view = view;
    vm.edit=edit;
    vm.deleteRols=deleteElem;
    vm.duplicate = duplicate;

    vm.llista = [];
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.errors=[];
    vm.auxentitatsel=[];

    vm.issuperadmin= $rootScope.issuperadmin;

    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      nom: '',
      entitatsel:[],
      identitat:''
    };


    if (!angular.isUndefined(llistaentitats)){
      vm.listallentitat=llistaentitats.data.list;
    }

    function onChangeFunction(){
      vm.cercaObj.identitat=null;
      if (vm.cercaObj.entitatsel!=null){
        if (vm.cercaObj.entitatsel.length>0){
          vm.cercaObj.identitat=vm.cercaObj.entitatsel[0].id;
        }
      }
    }

    if ($rootScope.issuperadmin){
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              columns: 6,
              required: false
            }
            ,
            {
                type: 'chips',
                name: 'entitatsel',
                list:vm.listallentitat,
                master: true,
                fieldProperty: 'nom',
                textPlaceholder: $translate.instant('USUARIENTITAT_CERCA'),
                columns: 6,
                label:"CERCA_ENTITATS",
                onChange :  onChangeFunction,
                mdMaxChips:2
            }
          ]
        }
      }
      else
      {
      vm.formulari = {
        nom: 'cercador',
        func: function(){
          cercar();
        },
        camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              columns: 6,
              required: false
            }]
        }
      }

 vm.formatter = formatter;
    function formatter(object, field) {
      var css = '';
      if (field === 'nom' && (object.liccaducada) ) {
        css = 'color:#dd2c00;';
      }
      return css;
    };




    function loadRols() {
      if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.ROL.read){
       vm.auxentitatsel=vm.cercaObj.entitatsel;
        vm.cercaObj.entitatsel=[];
        var promise = RolFactory.getAll(vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
              if(vm.issuperadmin || !entrada.liccaducada){
                vm.llista.push(entrada);
              }
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });
        vm.cercaObj.entitatsel=vm.auxentitatsel;
        return promise;
      }
      else
      {
        return undefined;
      }
    }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      loadRols();
    }

    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadRols().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }

    function calculateListFields(reductedList){
      if (reductedList){
        vm.fields = [
          {
            header: 'DEFAULT_NOM',
            type: 'text',
            name: 'nom'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];
      } else{
        vm.fields = [
          {
            header: 'DEFAULT_NOM',
            type: 'text',
            name: 'nom'
          },
          {
            header: 'DEFAULT_ENTITAT',
            type: 'text',
            name: 'nomentitat'
          },
          {
            header: 'DEFAULT_ACCIONS',
            type: 'actions',
            name: 'id'
          }
        ];

      }
    }



    function deleteElem(id) {
      $rootScope.$broadcast('$activateLoader');
      RolFactory.delete(id).then(function(response){
        $scope.$evalAsync(function(){
          /*if (id === $stateParams.idRol) {
            HelperFactory.setParams($stateParams, {'idRol': null});
            $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
          }*/

          vm.llista.forEach(function(elem, index) {
            if (elem.id === id){
                vm.llista.splice(index,1);
                vm.indexeliminat=index;
            }
          });
          if (vm.llista.length==0 )
          {
            HelperFactory.setParams($stateParams, {'idRol': null});
            $state.go('rols.main', $stateParams, {'reload': 'rols.main.submain'});
          }
          else
          {
            if (vm.llista.length==1)
            {
              view(vm.llista[0]);
            }
            else{
              if (vm.indexeliminat<vm.llista.length)
              {
                view(vm.llista[vm.indexeliminat]);
              }
              else
              {
                view(vm.llista[vm.indexeliminat-1]);
              }
            }
          }

        });
      $rootScope.$broadcast('$deactivateLoader');
      }).catch(function(error){
        $rootScope.$broadcast('$deactivateLoader');
        Notification.processError(error);
      });
    }




    function duplicate(id){
      $rootScope.$broadcast('$activateLoader');
      RolFactory.duplicate(id).then(function(response){
        cercar();
        $rootScope.$broadcast('$deactivateLoader');
      }).catch(function(error){
        $rootScope.$broadcast('$deactivateLoader');
        Notification.processError(error);
      });
    }

    function edit(id) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'isNew': false, 'idRol': id});
      $state.go('rols.main.submain.edit', $stateParams, {'reload': 'rols.main.submain'});
    }

    function view(obj) {
      $window.scrollTo(0,0);
      HelperFactory.setParams($stateParams, {'idRol': obj.id});
      $state.go('rols.main.submain.dades', $stateParams, {'reload': 'rols.main.submain'});
    }

     $scope.$on('addItemToTree', function(event, data) {
      HelperFactory.setParams($stateParams, {'isNew': true, 'idRol': undefined});
      $state.go('rols.main.submain.edit', $stateParams);
    });

    cercar();

    /*--------------------------------EVENTS ------------------------------*/

    $scope.$on('changeSides', function(event, data) {
      vm.calculateListFields(!data.left.collapsed && !data.links.collapsed);
    });

    $scope.$on('rols.main.delete', function(event, data) {
      deleteElem(data.id);
    });

     $scope.$on('rols.main.edit', function(event, data) {
      edit(data.id);
    });


    $scope.$on('rols.main.llista.update', function(event, data) {
      vm.llista.forEach(function(obj, index){
        if (obj.id === data.id) {
          obj.nom = data.nom;

          if (obj.nom.indexOf(vm.cercaObj.nom) == -1) {
            vm.llista.splice(index, 1);
          }
          Notification.success('GENERIC_SUCCESS');

          return;
        }
      });
    });

    $scope.$on('rols.main.llista.add', function(event, data) {
      $stateParams.idRol = data.id;
        if (vm.cercaObj.identitat== data.entitat[0].id ||vm.cercaObj.identitat==null ||vm.cercaObj.identitat=="" ){
          if (data.nom.indexOf(vm.cercaObj.nom) != -1 )  {
          vm.llista.push(data);
          }
        }

      view(data);
      Notification.success('GENERIC_SUCCESS');
    });

    if (angular.isUndefined($stateParams.idRol)){
      $rootScope.$broadcast('rols.main.showOptionSubmenu', {'show': false});
    }

  }
}());
